module.exports = __webpack_public_path__ + "static/media/add_white.0ce0de8c.svg";